import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { CiMail } from 'react-icons/ci';
import { PiPhoneCallThin } from 'react-icons/pi';
import { Tooltip } from '@mui/material';
import ScrollReveal from './ScrollReveal';
import { IoMdArrowRoundUp } from 'react-icons/io';

const Footer = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;

        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }

        // Calculate the scroll progress. This will be 0 at the top and 1 at the bottom.
        const scrollFraction = docHeight > 0 ? scrollTop / docHeight : 0;
        // We want the circle to be empty at the top and full at the bottom, so we use 1 - scrollFraction for the dash offset.
        setScrollProgress(1 - scrollFraction);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <footer className="bg-black text-white font-nixie-one relative px-4 md:px-10 lg:px-16">
            <div className="container mx-auto py-12 px-4">
                <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={200}>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
                        {/* Column 1: About */}
                        <div className="mb-6 md:mb-0 col-span-1 md:col-span-2 lg:col-span-1">
                            <div className='flex flex-col text-lg items-start lg:items-center'>
                                <a href='/' rel='noreferrer' className='decoration-none'>
                                    <img src='../assets/logo2.jpeg' alt='querencia micro credit' className='w-56 h-28 object-cover' />
                                </a>
                                {/* <p className='font-light text-center text-sm capitalize italic'>best VR solutions</p> */}
                            </div>
                        </div>

                        {/* Column 2: Quick Links */}
                        <div className="mb-6 md:mb-0">
                            <h4 className="font-semibold text-base mb-4 capitalize">Quick Links</h4>
                            <ul className="text-slate-400 text-sm space-y-2">
                                <li><a href='/' className="hover:text-blue-400 transition-colors font-semibold">Home</a></li>
                                <li><a href='/contactus' className="hover:text-blue-400 transition-colors font-semibold">Contact Us</a></li>
                                <li><a href='/aboutus' className="hover:text-blue-400 transition-colors font-semibold">About Us</a></li>
                                <li><a href='/faqs' className="hover:text-blue-400 transition-colors font-semibold">Faqs</a></li>
                            </ul>
                        </div>

                        {/* Column 3: Experiences */}
                        <div className="mb-6 md:mb-0">
                            <h4 className="font-semibold text-base mb-4 capitalize">Products</h4>
                            <ul className="text-slate-400 text-sm space-y-2">
                                <li><a href='/sme-loans' className="hover:text-blue-400 transition-colors font-semibold">SME Loans</a></li>
                                <li><a href='/business-loans' className="hover:text-blue-400 transition-colors font-semibold">Business Loans</a></li>
                                <li><a href='/salary-loans ' className="hover:text-blue-400 transition-colors font-semibold">Salary Loans</a></li>
                            </ul>
                        </div>

                        {/* Column 4: Contact us */}
                        <div className="mb-6 md:mb-0">
                            <h4 className="font-semibold text-base mb-4 capitalize">Get in touch</h4>
                            <ul className='flex flex-col items-start gap-2 md:gap-2 whitespace-nowrap font-light text-sm'>
                                <li className='flex flex-row items-start gap-1'>
                                    <Tooltip title="E-Mail" arrow>
                                        <CiMail className='text-xl hover:text-yellow-400' />
                                    </Tooltip>
                                    <div className='flex flex-col items-start text-sm'>
                                        <div className='flex flex-row items-start'>
                                            <p className='text-sm sm:text-sm capitalize cursor-pointer font-semibold'>email: </p>
                                            <div className='flex flex-col items-start gap-1'>
                                                <p className='text-sm sm:text-xs cursor-pointer text-slate-400 hover:text-blue-400 font-semibold'><a href="mailto:admin.hr@querenciamc.com"> admin.hr@querenciamc.com</a></p>
                                                <p className='text-sm sm:text-xs cursor-pointer text-slate-400 hover:text-blue-400 font-semibold'><a href="mailto:info@querenciamc.com"> info@querenciamc.com</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className='flex flex-row items-start capitalize gap-1'>
                                    <Tooltip title="Phone" arrow>
                                        <PiPhoneCallThin className='text-xl hover:text-blue-400' />
                                    </Tooltip>
                                    <div className='flex flex-col items-start text-sm'>
                                        <div className='flex flex-row items-start'>
                                            <p className='text-sm sm:text-sm capitalize cursor-pointer font-semibold'>phone: </p>
                                            <div className='flex flex-col items-start gap-1'>
                                                <p className='text-sm sm:text-xs cursor-pointer text-slate-400 hover:text-blue-400 font-semibold'><a href="tel:+233208328901"> +233 (0) 208328901</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        {/* Column 5: Social Media */}
                        <div className="mb-4 md:mb-0">
                            <h4 className="font-semibold text-base mb-4 capitalize">Connect With Us</h4>
                            <div className="flex space-x-4">
                                <a href="# " className="text-slate-400 hover:text-blue-400 transition-colors"><FaFacebookF size={20} /></a>
                                <a href="# " className="text-slate-400 hover:text-blue-400 transition-colors"><FaXTwitter size={20} /></a>
                                <a href="# " className="text-slate-400 hover:text-blue-400 transition-colors"><FaInstagram size={20} /></a>
                                <a href="# " className="text-slate-400 hover:text-blue-400 transition-colors"><FaLinkedinIn size={20} /></a>
                            </div>
                        </div>
                    </div>
                </ScrollReveal>
                <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={400}>
                    <div className="mt-5 pt-6 -mb-6 border-t border-gray-700 text-center text-gray-500 text-xs font-semibold">
                        <p>&copy; Copyright {new Date().getFullYear()} <span className='font-extrabold text-blue-400'>Querencia Micro Credit</span>. All Rights Reserved | <span><a href='/terms-of-service' className='hover:text-blue-400'>Private Policy & Terms of Service</a></span> | By <span className='hover:text-blue-400 hover:underline'><Link to={'https://samuelawuetey.onrender.com'} target='_blank' rel={'norefferer'}>89Devs Technologies</Link></span></p>
                    </div>
                </ScrollReveal>
            </div>

            {/* Scroll to Top Button */}
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-4 right-10 h-10 w-10 rounded-full bg-gray-700/80 backdrop-blur-sm text-white flex items-center justify-center shadow-lg hover:bg-blue-600 transition-all duration-300 z-50"
                    aria-label="Scroll to top"
                >
                    <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100">
                        {/* Background circle */}
                        <circle cx="50" cy="50" r="45" className="text-gray-600" strokeWidth="5" fill="none" />
                        {/* Progress circle */}
                        <circle cx="50" cy="50" r="45" className="text-blue-400" strokeWidth="5" fill="none"
                            strokeDasharray={2 * Math.PI * 45}
                            strokeDashoffset={(2 * Math.PI * 45) * scrollProgress}
                            style={{ transform: 'rotate(-90deg)', transformOrigin: '50% 50%', transition: 'stroke-dashoffset 0.1s linear' }} />
                    </svg>
                    <IoMdArrowRoundUp className='text-xl' />
                </button>
            )}
        </footer>
    );
};

export default Footer;